<template>
  <div class="bgAmap-container" id="indexMap">
    <el-amap
      ref="map"
      vid="indexDemo"
      :center="center"
      :zoom="zoom"
      :amap-manager="amapManager"
      :events="mapEvents"
      class="index-demo"
    >
      <template v-for="(marker, index) in markers">
        <el-amap-marker
          v-if="marker && !isNaN(marker.longitude) && !isNaN(marker.latitude) && marker.longitude !== null && marker.latitude !== null"
          :key="index"
          :position="[Number(marker.longitude), Number(marker.latitude)]"
          :icon="marker.is_double?home_point_double:home_point"
          :offset="[-20, -68]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.title"
        >
        </el-amap-marker>
      </template>
      <el-amap-info-window
        isCustom="true"
        :position="currentWindow.position"
        :visible="currentWindow.visible"
        :events="{ close: () => closeWin() }"
        closeWhenClickMap="true"
      >
        <div class="item_map">
          <div class="close-window" @click="closeWin()">
            <i class="el-icon-close"></i>
          </div>
          <h3 class="info-title" :title="lampInfo.name">
            {{ lampInfo.name }}
          </h3>
          <div class="info-content">
            <div v-html="getGasValue(lampInfo.sb)"></div>
          </div>
          <div class="info-controls">
            <div class="botton-one" @click="backLightList(lampInfo.lamp_id)">
              <div class="icon">
                <svg-icon name="lamp-control"/>
              </div>
              <div class="text">路灯控制</div>
            </div>
            <div v-if="lampInfo.camera_list&&lampInfo.camera_list.length" class="botton-one" @click="videoPreview(lampInfo.camera_list[0])">
              <div class="icon">
                <svg-icon name="video-preview"/>
              </div>
              <div class="text">摄像头</div>
            </div>
          </div>
        </div>
      </el-amap-info-window>
    </el-amap>

    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看路灯监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_home_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_home_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import VueAMap from "vue-amap";
import lampsApi from "@/api/device/lamps";
import cameraApi from "@/api/device/camera";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import store from '@/store'
let amapManager = new VueAMap.AMapManager();
export default {
  name: "bgAmap",
  components: {
    videoBox,
    videoControl
  },
  data() {
    return {
      home_point: require('../../assets/home_images/home_point.png'),
      home_point_double: require('../../assets/home_images/home_point_double.png'),
      amapManager,
      mapEvents: {
        init(o) {
          o.setMapStyle("amap://styles/grey");
        },
      },
      zoom: 16,
      center: store.state.user.account_map.center,
      currentWindow: {
        position: store.state.user.account_map.center,
        visible: false,
      },
      markers: [],
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      },
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    };
  },
  created() {
    // console.log('store.state.user', store.state.user)
    this.getLampList();
  },
  methods: {
    init: function () {
      //地图初始化
      map = new AMap.Map("indexMap", {
        resizeEnable: true,
      });
    },
    getLampList() {
      lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(this.$store.state.user.role_type==1){
            this.zoom=8
          }else{
            this.zoom=18
          }
          this.markers = resData.list;
        }
      });
    },
    markerClick(marker) {
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
      setTimeout(function () {
        this.center = [Number(marker.longitude), Number(marker.latitude)];
      }, 200);
    },
    closeWin() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    getGasValue(items) {
      let gas_data = [
        "北风",
        "东北风",
        "东风",
        "东南风",
        "南风",
        "西南风",
        "西风",
        "西北风",
      ];
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    videoPreview(video) {
      if (!this.video.number) {
        return
      }
      cameraApi.cameraInfo({
        number: video.number,
        channel: video.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    backLightList(){
      this.$router.push({
        name: 'lamps',
        path:"/device/lamps"
      })
    }
  }
};
</script>

<style lang='less'>
@color-primary:#336b96;
.bgAmap-container {
  width:100%;
  height:100%;
  position: relative;
  z-index: 1;
  .index-demo {
    position: absolute;
    width:100%;
    height:100%;
    overflow: hidden;
    z-index: 1;
  }

  .amap-logo {
    display: none !important;
    opacity: 0 !important;
  }
  .amap-layers {
    background: #09152a !important;
  }

  .item_map {
    background-image: url("../../assets/home_images/item_map.png");
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 20px;
    border-radius: 20px;
    border: 2px solid #e8c255;
    position: relative;
    min-width: 200px;
    box-sizing: border-box;
    color: #fff;
    .close-window {
      width: 26px;
      height: 26px;
      border-radius: 26px;
      cursor: pointer;
      background: #413c33;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      z-index: 99999;
      i {
        color: #fff;
        font-size: 18px;
      }
    }
    .close-window:hover {
      background: #332d24;
    }
    h3.info-title {
      margin: 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 18px;
    }
    .info-content {
      margin: 5px 0;
      overflow: hidden;
    }
    .info-content span {
      width: 150px;
      float: left;
    }
    .info-controls {
      padding:5px 10px 10px;
      display: flex;
      align-items: center;
      .botton-one{
        margin-right: 20px;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .icon{
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          background-color: #715f2a;
          color:#fff;
        }
        .text{
          padding: 5px 0;
          font-size: 14px;
          text-align: center;
          color:#fff;
        }
        &:hover{
          .icon{
            border: 1px solid rgba(255, 255, 255, 1);
            color:#fff;
            background-color: #8b7533;
          }
          .text{
            color:#8b7533;
          }
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .item_map:after {
    position: absolute;
    content: "";
    z-index: -1;
    bottom: -8px;
    left: 50%;
    margin-left: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #e8c255;
  }
}

.video-left{
  width:600px;
  height:400px;
  float: left;
}
.video-right{
  float: right;
}
</style>
